import { Component, Input } from '@angular/core';

@Component({
  selector: 'fulltitle',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss']
})
export class TitleComponent {

  @Input()
  english: boolean;

  // *** Content *** //

  @Input()
  title: string;

  @Input()
  imgurl: string;

  // ***************************** //

  constructor() { }

  scrollDown() {
    window.scrollTo({
      left: 0,
      top: window.innerHeight,
      behavior: 'smooth',
    });
  }
}
